// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1sj5C","inputDescription":"styles_inputDescription__21ozh"};